import { Field, Formik } from "formik";
import { useEffect } from "react";
import { useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import { AiFillSave } from "react-icons/ai";
import * as Yup from 'yup';
import SelectAjax from "../../../components/SelectAjax";
import { DISEASE_SAVE, ESPECIALITIES_ALL } from "../../../api/Routes";
import Post from "../../../api/Post";
import LoadingList from "../../../loader/LoadingList";
import { toast } from "react-toastify";

export default function AddDiagnostico({auth, itemToEdit, setItemToEdit, setShowModalError, setErrorServer, recheck, setRecheck}){
    const [submit, setSubmit] = useState(false)
    const [especialidad, setEspecialidad] = useState(null)
    const [initialValues, setInitialValues] = useState({
        id: null,
        code4digits: '',
        description: '',
        active: true,
        common: false,
        especialty: {
            id: ''
        }
    })
    const shemaValidate = Yup.object().shape({
        code4digits:Yup.string().required('Campo Requerido'),
        description:Yup.string().required('Campo Requerido'),
        especialty: Yup.object().shape({
            id: Yup.string().required('Campo Requerido'),
        })
    });

    useEffect(() => {
        if(itemToEdit){
            setInitialValues({
                id: itemToEdit.id,
                code4digits: itemToEdit.code4digits,
                description: itemToEdit.description,
                active: itemToEdit.active,
                common: itemToEdit.common,
                especialty: {
                    id: itemToEdit.especialty.id,
                    name: itemToEdit.especialty.name
                }
            })
            setEspecialidad(
                {
                    label: itemToEdit.especialty.name,
                    value: itemToEdit.especialty.id,
                }
            )
        }
    },[itemToEdit])

    return (
        <>
            <Row>
                <Col>
                    <Formik
                        enableReinitialize 
                        initialValues={initialValues}
                        validationSchema={shemaValidate}
                        onSubmit={async (values, { setSubmitting, setFieldValue }) => { 
                            console.log(values)  
                            setSubmit(true)
                            try {
                                const response = await Post({url: DISEASE_SAVE, data: values,  header:true, access_token:auth.data.access_token})
                                console.log(response)
                                setSubmit(false)
                                setRecheck(!recheck)
                                setInitialValues({
                                        id: '',
                                        code4digits: '',
                                        description: '',
                                        active: true,
                                        common: false,
                                        especialty: {
                                            id: ''
                                        }
                                })
                                setEspecialidad(null)
                                setItemToEdit(null)
                                toast.success("Acción exitosa", {autoClose: 3000})
                            } catch (error) {
                                setShowModalError(true)
                                if(error.response){
                                    setErrorServer(error.response)
                                }
                                setSubmit(false)
                            }   
                        }}
                    >{({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        resetForm,
                    }) => (
                        <Form onSubmit={handleSubmit}  className='mt-3'>
                            {submit && <LoadingList texto='Procesando solicitud' />}
                            <Card className="shadow-1 formSection">
                                <Card.Body>
                                    <Row>
                                        <Col xs="12" md="12">
                                            <h4>
                                                <span className="subtitulo">{initialValues.id ? 'Editar' : 'Agregar'} Diagnóstico
                                                </span>
                                            </h4>
                                        </Col>
                                    </Row>
                                    <div className="body">
                                        <Row>
                                            <Col xs="12" md="12">
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Código</Form.Label>
                                                    <Field 
                                                        type="text"
                                                        className={`form-control input-form ${errors.code4digits && 'error'}`}
                                                        name="code4digits"
                                                    />
                                                    { errors.code4digits && <div className="invalid-feedback d-block">{errors.code4digits}</div> }
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" md="12">
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Descripción</Form.Label>
                                                    <Field 
                                                        type="text"
                                                        className={`form-control input-form ${errors.description && 'error'}`}
                                                        name="description"
                                                    />
                                                    { errors.description && <div className="invalid-feedback d-block">{errors.description}</div> }
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" md="12">
                                                <Form.Group>
                                                    <Form.Label className="font-weight-bold-600 text-secondary">Especialidad</Form.Label>
                                                    <SelectAjax
                                                        value={especialidad}
                                                        url={ESPECIALITIES_ALL}
                                                        access_token={auth.data.access_token}
                                                        isMulti={false}
                                                        handleChange={(value) => {
                                                            setEspecialidad(value)
                                                            if(value){
                                                                setFieldValue('especialty.id', value.value)
                                                            }else{
                                                                setFieldValue('especialty.id', '')
                                                            }
                                                        }} 
                                                        defaultOptions={[]}   
                                                        valid={true}     
                                                        isClearable={false}
                                                        className='input-form' 
                                                        placeholder={"Seleccionar opción"}                                                   
                                                    />
                                                    { errors.especialty?.id && <div className="invalid-feedback d-block">{errors.especialty?.id}</div> }
                                                </Form.Group>
                                            </Col>
                                            <Col xs="12" md="12">
                                                <div className="form-check form-check-inline">                                                    
                                                    <Field
                                                        className="form-check-input"
                                                        name="active" 
                                                        type="checkbox"
                                                    />
                                                    <label className="form-check-label">Activo</label>
                                                </div>
                                            </Col>
                                            <Col xs="12" md="12">
                                                <div className="form-check form-check-inline">
                                                    <Field
                                                        className="form-check-input"
                                                        name="common" 
                                                        type="checkbox"
                                                    />
                                                    <label className="form-check-label">Común</label>
                                                </div>
                                            </Col>
                                            <Col xs="12" md="12">
                                                {
                                                    initialValues.id &&
                                                    <Button type="button" variant="outline-danger" className='float-right'
                                                        onClick={() => {
                                                            setInitialValues({
                                                                id: '',
                                                                code4digits: '',
                                                                description: '',
                                                                active: true,
                                                                common: false,
                                                                especialty: {
                                                                    id: ''
                                                                }
                                                            })
                                                            setEspecialidad(null)
                                                            setItemToEdit(null)
                                                        }}
                                                    >Cancelar</Button>
                                                }
                                                <Button type="submit" variant="link" className='btn-add float-right'>
                                                    <AiFillSave className="icon-save"/>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>   
                                </Card.Body>
                            </Card>
                        </Form>
                    )}</Formik>
                </Col>
            </Row>
        </>
    )
}